import * as ko from "knockout";
import * as moment from "moment";
import Bao from "./../../services/bao-service";
import BaoDialog from "../../factories/bao-dialog";
import BaoRouter from "../../services/bao-router";

/**
 * Class to represent the viewmodel for the ShiftPersonal-Workplace-Report.
 */
class ShiftPersonalWorkplaceReport {

    //#region Constructors

    /**
     * Initializes a new Instance of the ShiftPersonalWorkplaceReport-Class.
     * @param parent The Parent-Objekt, which contains this control.
     */
    constructor(parent: any) {

        this.Parent = parent;
        this.TabPage = parent.TabPage;

        // Set Date-Filter default values
        this.ReportStartDate(moment().startOf('year').format(Bao.Utils.DateTimeFormat));
        this.ReportEndDate(moment().format(Bao.Utils.DateTimeFormat));

        this.ShiftbookIds.subscribe((newValue) => {
            this.OnShiftbookIdChanged(newValue);
        });
    }

    //#endregion

    //#region Properties

    /**
     * Gets or sets the instance of the parent-object.
     */
    protected Parent: any = null;

    /**
     * The TabPage, which contains this control.
     */
    protected TabPage: Factories.TabPage = null;

    /**
     * Gets the GUID for the ShiftbookType-Filter.
     */
    protected ShiftbookSearchShiftbookTypeId: string = "1AB743AA-C33C-4DB9-8920-3C8E79B501E3";

    /**
     * Gets the URL which should be used to create the report.
     */
    protected GenerateReportUrl: string = "ReportCenter/GenerateShiftPersonalWorkplaceReport";

    /**
     * Gets or sets the Filter-Startdate.
     */
    public ReportStartDate: KnockoutObservable<string> = ko.observable();

    /**
    * Gets or sets the Filter-Enddate.
    */
    public ReportEndDate: KnockoutObservable<string> = ko.observable();

    /**
     * Gets or sets the Shiftbook-ID's for the filter.
     */
    public ShiftbookIds: KnockoutObservableArray<string> = ko.observableArray();

    /**
     * Gets or sets the display-name of the Shiftbook-filter.
     */
    public ShiftbookIdNames: KnockoutObservable<string> = ko.observable();

    /**
     * Gets or sets the Shift-ID's for the filter.
     */
    public ShiftIds: KnockoutObservableArray<string> = ko.observableArray();

    /**
     * Gets or sets the display-name of the Shift-filter.
     */
    public ShiftIdNames: KnockoutObservable<string> = ko.observable();

    /**
     * Gets or sets the ShiftWorker-ID's for the filter.
     */
    public ShiftWorkerIds: KnockoutObservableArray<string> = ko.observableArray();

    /**
     * Gets or sets the display-name of the SiftWorker-filter.
     */
    public ShiftWorkerNames: KnockoutObservable<string> = ko.observable();

    /**
     * Gets the BaoSearcher to search for Shiftbooks.
     */
    public SearcherShiftbook: Bindings.baoSearcher = {
        ObjectId: this.ShiftbookIds as any,
        ObjectValue: 'ModelTitle',
        SearchType: 'Shiftbook',
        MultiSelect: true,
        AutoSearch: true,
        AutoComplete: true,
        CustomFilter: {
            ShiftbookTypeId: this.ShiftbookSearchShiftbookTypeId
        }
    };

    /**
     * Gets the BaoSearcher to search for Shifts.
     */
    public SearcherShift: Bindings.baoSearcher = {
        ObjectId: this.ShiftIds as any,
        ObjectValue: 'ModelTitle',
        SearchType: 'ShiftType',
        MultiSelect: true,
        AutoSearch: true,
        AutoComplete: true,
        CustomFilter: {
            ShiftbookIds: null
        }
    };

    /**
     * Gets the BaoSearcher to search for Workers.
     */
    public SearcherShiftWorker: Bindings.baoSearcher = {
        ObjectId: this.ShiftWorkerIds as any,
        ObjectValue: 'ModelTitle',
        SearchType: 'PersonInternal',
        MultiSelect: true,
        AutoSearch: true,
        AutoComplete: true,
        CustomFilter: {
            ShiftbookId: null
        }
    }

    /**
     * Gets the BaoDateTimeBox to select the filter-startdate.
     */
    public DateTimeBoxReportStartDate: Bindings.baoDateTimeBox = {
        mode: 'date',
        culture: Bao.Session.Language.Symbol,
        value: this.ReportStartDate
    };

    /**
     * Gets the BaoDateTimeBox to select the filter-enddate.
     */
    public DateTimeBoxReportEndDate: Bindings.baoDateTimeBox = {
        mode: 'date',
        culture: Bao.Session.Language.Symbol,
        value: this.ReportEndDate
    };

    /**
     * Gets the BaoDateTimePicker-instance.
     */
    public DateTimePicker: Bindings.baoDateTimePicker = {
        mode: 'date'
    };

    //#endregion

    //#region Public Methods

    /**
     * Starts the download of the Report and applies all selected filters.
     */
    public DownloadReport(): void {
        this.TabPage.IsLoading(true);

        Bao.post(this.GenerateReportUrl, JSON.stringify({
            startDate: this.ReportStartDate(),
            endDate: this.ReportEndDate(),
            shiftbooks: JSON.stringify(this.ShiftbookIds()),
            shifts: JSON.stringify(this.ShiftIds()),
            workers: JSON.stringify(this.ShiftWorkerIds())
        })).done(result => {
            this.TabPage.IsLoading(false);

            if (result.Result == true) {
                BaoRouter.setHash("document/" + result.Message);
            }
        });
    }

    //#endregion

    //#region Protected Methods

    /**
     * Is called when the ShiftbookIds-Property changes.
     * @param newValue The newValue of the Property.
     */
    protected OnShiftbookIdChanged(newValue: string[]): void {
        (this.SearcherShift.CustomFilter as any).ShiftbookIds = JSON.stringify(newValue);
        (this.SearcherShiftWorker.CustomFilter as any).ShiftbookId = JSON.stringify(newValue);
        this.ShiftIds(null);
        this.ShiftIdNames(null);
        this.ShiftWorkerIds(null);
        this.ShiftWorkerNames(null);
    }

    //#endregion
}
export default ShiftPersonalWorkplaceReport;